@if (title) {
  <h2 mat-dialog-title>{{ title }}</h2>
}
@if (content) {
  <mat-dialog-content [innerHTML]="content | markdown | async"></mat-dialog-content>
}
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="handleOkClick()">
    @if (counter > 0) {
      <span> {{ 'EXECUTE' | translate }} {{ ' (' + counter + ') ' }} </span>
    } @else {
      {{ okButton }}
    }
  </button>
  @if (secondOption) {
    <button mat-raised-button (click)="dialogRef.close('second')">
      {{ secondOption }}
    </button>
  }
  <button mat-raised-button (click)="dialogRef.close()">
    {{ cancelButton }}
  </button>
</div>
